import React from "react";
import { DropDown, Button } from "../../components";

const RentingProduct = (props: any) => {
  const { rentingProducts, handleRentDurationChange, handleRentStartTimeChange, startTime, setRentProductQuantity, rentProductQuantity, handleRentAdd, rentData } = props
  return (
    <div className="table-responsive">
      <table className="table align-middle fs-7">
        <thead>
          <tr>
            <th>Sr. No.</th>
            <th>Product</th>
            <th>Available Qty.</th>
            <th>Service Price / 30 min</th>
            <th>Duration</th>
            <th>Start Time</th>
            <th>Qty</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {rentingProducts?.map((item: any, index: number) => {
            return (
              <tr key={"rent-data-" + item.id}>
                <td>{index + 1}</td>
                <td>{item.name}</td>
                <td>{item.availableQuantity}</td>
                <td>{item.rentingPrice}</td>
                <td style={{ width: '100px' }}>
                  <div className="">
                    <DropDown className="form-control sell-input fs-7 px-1" value={item.duration} onChange={(e: any) => handleRentDurationChange(e, index)} >
                      <option value={30}>30 min</option>
                      <option value={60}>1 hr</option>
                      <option value={90}>1:30 hr</option>
                      <option value={120}>2 hr</option>
                      <option value={150}>2:30 hr</option>
                      <option value={180}>3 hr</option>
                      <option value={210}>3:30 hr</option>
                      <option value={240}>4 hr</option>
                      <option value={270}>4:30 hr</option>
                      <option value={300}>5 hr</option>
                      <option value={330}>5:30 hr</option>
                      <option value={360}>6 hr</option>
                      <option value={390}>6:30 hr</option>
                      <option value={420}>7 hr</option>
                      <option value={450}>7:30 hr</option>
                      <option value={480}>8 hr</option>
                      <option value={510}>8:30 hr</option>
                      <option value={540}>9 hr</option>
                      <option value={570}>9:30 hr</option>
                      <option value={600}>10 hr</option>
                      <option value={630}>10:30 hr</option>
                      <option value={660}>11 hr</option>
                      <option value={690}>11:30 hr</option>
                      <option value={720}>12 hr</option>
                    </DropDown>
                  </div>
                </td>
                <td style={{ width: '90px' }}>
                  <DropDown
                    id="startTime"
                    name="startTime"
                    className="form-control fs-7 px-1"
                    value={item.startTime}
                    onChange={(e: any) => handleRentStartTimeChange(e, index)}
                  >
                    <option hidden disabled value="">Select Start Time</option>
                    {
                      startTime().map((elem: string) => (
                        <option key={elem} value={elem}>
                          {elem}
                        </option>
                      ))
                    }
                  </DropDown>
                </td>
                <td className="text-nowrap">
                  <div className="quantity-input">
                    <Button
                      className="minus"
                      bname="-"
                      name="minus"
                      id="minus"
                      onClick={() =>
                        setRentProductQuantity((_oldData: any) => ({
                          ..._oldData,
                          [item?.id]:
                            rentProductQuantity[item?.id] > 0 ? rentProductQuantity[item?.id] - 1 : 0
                          ,
                        }))
                      }
                    >
                      -
                    </Button>
                    <input
                      type="text"
                      className="form-control"
                      style={{ width: "50px" }}
                      id="quantity"
                      value={Number(rentProductQuantity[item?.id]) || 0}
                      onChange={(e: any) =>
                        e.target.value <= rentData[index]?.availableQuantity && setRentProductQuantity((_oldData: any) => ({
                          ..._oldData,
                          [item?.id]: e.target.value
                        }))
                      }
                    />
                    <Button
                      className="plus"
                      bname="+"
                      id="plus"
                      name="plus"
                      onClick={() =>
                        setRentProductQuantity((_oldData: any) => ({
                          ..._oldData,
                          [item?.id]:
                            rentProductQuantity[item?.id] < rentData[index]?.availableQuantity ? Number(rentProductQuantity[item?.id]) + 1 : rentData[index]?.availableQuantity
                        }))
                      }
                    >
                      +
                    </Button>
                  </div>
                </td>
                <td className="text-nowrap">
                  <Button
                    onClick={() => handleRentAdd(item?.id, index)}
                    bname="Add to Cart"
                    id="addtocart"
                    name="addtocart"
                    className="btn btn-sm btn-primary"
                  ></Button>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export { RentingProduct }